const PREFIX = 'uf/intercom';
export const INITIALIZE_INTERCOM = `${PREFIX}/INITIALIZE`;
export const SHOW_INTERCOM = `${PREFIX}/SHOW`;
export const UPDATE_INTERCOM = `${PREFIX}/UPDATE`;
